import { WppSkeleton } from '@wppopen/components-library-react'
import { TypographyType } from '@wppopen/components-library/dist/types/components/wpp-typography/types'

interface TypographySkeletonProps {
  type: TypographyType
  className?: string
  width?: number
  height?: number
  slot?: string
}

const TypographySkeleton = ({ type, className, width, height, slot }: TypographySkeletonProps) => {
  // Keep in sync with: apps/commerce-studio/src/styles/theme.scss
  const typographyLineHeightMap = new Map<TypographyType, number>([
    ['2xs-strong', 20],
    ['xs-body', 20],
    ['xs-midi', 20],
    ['xs-strong', 20],
    ['l-body', 28],
    ['s-body', 22],
    ['s-midi', 22],
    ['s-strong', 22],
    ['m-body', 24],
    ['m-midi', 24],
    ['m-strong', 24],
    ['l-midi', 28],
    ['l-strong', 28],
    ['xl-heading', 32],
    ['2xl-heading', 32],
    ['3xl-heading', 40],
    ['4xl-display', 48],
    ['5xl-display', 62],
  ])
  const typographySizeMap = new Map<TypographyType, number>([
    ['2xs-strong', 10],
    ['xs-body', 12],
    ['xs-midi', 12],
    ['xs-strong', 12],
    ['l-body', 14],
    ['s-body', 14],
    ['s-midi', 14],
    ['s-strong', 16],
    ['m-body', 16],
    ['m-midi', 16],
    ['m-strong', 18],
    ['l-midi', 18],
    ['l-strong', 18],
    ['xl-heading', 20],
    ['2xl-heading', 24],
    ['3xl-heading', 28],
    ['4xl-display', 36],
    ['5xl-display', 48],
  ])

  const multiplier = 5
  const lineHeight = typographyLineHeightMap.get(type)! || typographyLineHeightMap.get('s-strong')!
  const fontHeight = typographySizeMap.get(type)! || typographySizeMap.get('s-strong')!
  const margin = (lineHeight - fontHeight) / 2

  return (
    <WppSkeleton
      variant="rectangle"
      width={width || lineHeight * multiplier}
      height={height || fontHeight}
      className={className}
      style={{ marginBlock: height ? 'auto' : margin }}
      slot={slot || ''}
      data-testid="typography-skeleton"
    />
  )
}

export default TypographySkeleton
